import type { EmailDesign } from "../../../../email-design/server/supabase-email-design-service";

export function calculatePaperSize(
  layout_settings?: EmailDesign["layout_settings"],
): number | undefined {
  const paperSize =
    layout_settings &&
    layout_settings?.max_paper_width -
      // the padding is on both sides
      2 * (layout_settings?.paper_padding_side ?? 0);

  // If the paper size is not a number, set it to undefined
  // So that downstream defaults are used
  if (typeof paperSize === "number" && isNaN(paperSize)) {
    return undefined;
  }

  return paperSize ?? undefined;
}
